// https://stackoverflow.com/questions/46376468/how-to-get-type-of-array-items

export type GetElementType<T extends any[]> = T extends (infer U)[] ? U : never;
